// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"56d76655","32":"1f60feb0","208":"197ce82f","601":"81a39466","786":"d2cf9431"}[chunkId] + ".chunk.css";
};